<template>
  <v-app>
    <NavbarPublica />

    <v-row class="justify-center ma-0">
      <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
        <p>Carregando...</p>
        <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
      </div>
      <v-col
        class="col-12 col-sm-12 col-md-11 col-lg-11"
        v-if="!isLoading"
        :class="{'pt-3': $vuetify.breakpoint.smAndDown, 'pt-5': $vuetify.breakpoint.mdAndUp}"
      >
        <v-container>
          <v-row class="justify-center align-center my-2" v-if="category != 'psychologist'">
            <v-col class="col-md-5">
              <v-row class="aling-center ma-0">
                <v-icon class="primary--text mr-3" size="40">record_voice_over</v-icon>
                <h2 class="mx-2 text-center text-md-left">Psicólogo</h2>
              </v-row>
            </v-col>
            <v-col class="col-md-5">
              <Agendar
                :cod="user.id"
                :justifyPosition="'end'"
                :styleButton="`height: 50px; font-size: 1.3rem;`"
              />
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col class="col-12 col-md-5 col-lg-5 px-3">
              <v-col class="col-12 d-flex align-center justify-end">
                <div
                  class="pa-3 pl-lg-12 box-psicologo d-flex flex-column align-center justify-center justify-md-end"
                >
                  <div class="avatar-psicologo">
                    <v-avatar size="90">
                      <v-img v-if="user.photo != ''" :src="user.photo">
                        <template v-slot:placeholder>
                          <v-row fill-height align-center justify-center ma-0>
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-img v-if="user.photo == ''" :src="require('../../assets/no-image.png')"></v-img>
                    </v-avatar>
                  </div>
                  <p class="mb-2 color-gray font-weight-bold f-textoCorpoSection">{{ user.name }}</p>
                  <p class="ma-0 color-gray">
                    <span class="font-weight-bold">Nacionalidade:</span>
                    {{ user.country }}
                  </p>
                </div>
              </v-col>
              <div class="d-flex align-center">
                <v-col class="col-6 ml-2">
                  <p class="ma-0 color-gray">
                    <span class="font-weight-bold">Sexo:</span>
                    {{ user.gender }}
                  </p>
                </v-col>
                <v-col v-if="user.date_birth" class="col-6">
                  <p class="ma-0 text-left text-md-right mr-md-5 my-3 color-gray">
                    <span class="font-weight-bold">Nascimento:</span>
                    {{ user.date_birth }}
                  </p>
                </v-col>
              </div>
              <v-divider></v-divider>
              <div class="d-flex align-center">
                <v-col class="col-6 ml-2">
                  <p class="ma-0 color-gray">
                    <span class="font-weight-bold">{{$t('pageProfile.labelDestrito')}}:</span>
                    {{ user.state }}
                  </p>
                </v-col>
                <v-col class="col-6">
                  <p class="ma-0 text-left text-md-right mr-md-5 my-3 color-gray">
                    <span class="font-weight-bold">Cidade:</span>
                    {{ user.city }}
                  </p>
                </v-col>
              </div>
              <v-divider></v-divider>

              <div
                class="d-flex flex-column flex-md-row align-center justify-center pa-3 mt-5"
                style="background: #FFFDE3;"
              >
                <p
                  class="ma-0 text-center font-weight-bold f-14 mr-md-5 my-3 primary--text"
                >
                  Área de Atuação:
                  <span
                    class="ma-0 text-center font-weight-bold mr-md-5 my-3 color-gray"
                  >{{ user.academic_degree }}</span>
                </p>
              </div>
              <v-divider class="mt-5"></v-divider>

              <div class="px-3">
                <v-row
                  class="align-center mt-5"
                  v-if="user.opp != '' && user.opp != null"
                  style="background: #e8e8e8"
                >
                  <v-col class="col-12">
                    <p class="ma-0 text-center font-weight-bold f-14 mr-md-5 my-3 gray--text">
                      OPP:
                      <span>{{ user.opp }}</span>
                    </p>
                  </v-col>
                  <!-- <v-col class="col-12 col-md-6">
                    <p
                      class="ma-0 text-center font-weight-bold f-textoCorpoSection mr-md-5 my-3 gray--text"
                    >CRP: <span>{{ user.crp }}</span></p>
                  </v-col>-->
                </v-row>

                <v-row
                  class="align-center mt-5"
                  v-if="user.crp != '' && user.crp != null"
                  style="background: #e8e8e8"
                >
                  <v-col class="col-12">
                    <p class="ma-0 text-center font-weight-bold f-14 mr-md-5 my-3 gray--text">
                      CRP:
                      <span>{{ user.crp }}</span>
                    </p>
                  </v-col>
                </v-row>
                <v-row
                  class="align-center mt-5"
                  v-if="user.is_chief_therapist"
                  style="background: #e8e8e8"
                >
                  <v-col class="col-12">
                    <div class="d-flex align-center justify-center">
                      <v-icon dark class="primary--text icon-psy-name" size="32">bookmark</v-icon>
                      <p class="ma-0 text-left font-weight-bold f-14 text-md-right mr-md-5 my-3 gray--text">Terapeuta Chefe</p>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="align-center justify-center mt-5" style="background: #e8e8e8">
                  <v-col class="col-12 d-flex flex-row align-center justify-center">
                    <p
                      class="ma-0 text-left font-weight-bold f-14 text-md-right mr-md-5 my-3 gray--text"
                    >Valor da Consulta:</p>
                    <p
                      class="ma-0 text-left f-14 text-md-right mr-md-5 my-3 color-green"
                      v-if="user.appointment_br_value != '0.00' && user.appointment_br_value != null"
                    >R$ {{user.appointment_br_value}}</p>
                    <p
                      class="ma-0 text-left f-14 text-md-right mr-md-5 my-3 color-green"
                      v-if="user.appointment_pt_value != '0.00' && user.appointment_pt_value != null"
                    >€ {{user.appointment_pt_value}}</p>
                  </v-col>
                </v-row>

                <v-row class="align-center justify-center mt-5" style="background: #e8e8e8">
                  <v-col class="col-12 d-flex flex-row align-center justify-center">
                    <p
                      class="ma-0 text-left font-weight-bold f-14 text-md-right mr-md-5 my-3 primary--text"
                    >Reputação:</p>
                    <div class="d-flex flex-row align-center justify-center">
                      <p
                        class="ma-0 text-left font-weight-bold f-14 text-md-right mt-1 color-gray"
                      >{{user.average}}/5</p>
                      <v-img
                        :src="require('../../assets/md-star.svg')"
                        style="width: 40px;"
                        class="ml-3"
                      ></v-img>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <!-- <div>
                <h3 class="my-4">{{$t('pageProfile.titleContato')}}</h3>
                <div>
                  <div class="mb-3 box-contact d-flex align-center" v-if="user.email">
                    <span>Email</span>
                    <v-img :src="require('../../assets/icon-mail.svg')" width="28px" class="mx-2"></v-img>
                    <p>{{ user.email }}</p>
                  </div>
                  <v-divider class="mb-3"></v-divider>

                  <div
                    class="mb-3 box-contact d-flex flex-column align-center justify-center"
                    style="justify-content: center;"
                  >
                    <p class="titulo-habilitacoes">Habilitações Académicas:</p>
                    <p>{{ user.academic_degree }}</p>
                  </div>

                  <div
                    class="mb-3 box-contact d-flex align-center"
                    style="justify-content: center;"
                  >
                    <span class="primary--text">Avaliação:</span>
                    <p>{{user.average}}</p>
                    <v-img :src="require('../../assets/md-star.svg')" width="40px" class="mx-3"></v-img>
                  </div>

                  <div
                    class="mb-3 box-contact d-flex align-center"
                    style="justify-content: center;"
                  >
                    <v-img :src="require('../../assets/icon-money.svg')" width="32px" class="mx-2"></v-img>
                    <span class="mx-2">Valor da Consulta:</span>
                    <p v-if="user.appointment_br_value != '0.00'">R$ {{user.appointment_br_value}}</p>
                    <p v-else>€ {{user.appointment_pt_value}}</p>
                  </div>
                </div>
              </div>-->
            </v-col>
            <v-col class="col-12 col-md-5 col-lg-5 px-3">
              <div>
                <p class="mt-4 primary--text f-15">Especialidades</p>
                <v-row>
                  <v-col
                    class="shrink pa-1 my-2 col-auto"
                    v-for="(especiality,index) in user.specialities"
                    :key="index"
                  >
                    <span class="specialities">{{especiality}}</span>
                  </v-col>
                </v-row>
                <v-divider class="mt-5"></v-divider>
                <div class="box-contact align-center">
                  <p class="m-0 f-15 primary--text">{{$t('pageProfile.psiBio')}}:</p>
                  <p class="text-justify font-weight-light biographty-text">{{ user.biography }}</p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import Axios from 'axios';
import moment from 'moment-timezone';
import Agendar from '../../components/Agendar';
import NavbarPublica from '../../components/NavbarPublica';
import Api from '../../services/httpClient';

export default {
  data: () => ({
    user: {},
    cod: '',
    specialities: [],
    banco: [],
    items: [{ text: 'Branco do Brasil' }],
    isEdit: true,
    isLoading: false,
    average_rating: '0/5',
    category: 'psychologist',
  }),
  components: {
    Agendar,
    NavbarPublica,
  },

  async mounted() {
    this.getCategory();
  },

  async created() {
    if (this.$route.params.id) {
      const { id } = this.$route.params;
      await this.getUser(id);
      // console.log('tenho meu cod? ', id);
    }
  },

  methods: {
    getUser(slug) {
      this.isLoading = true;
      Api.get(
        `/psychologist-by-slug/${slug}/`,
      ).then(response => {
        this.user = response.data;

        console.log('this.user ', this.user);
        this.formatData(this.user.date_birth);
        // this.getSpecialities()
        this.isLoading = false;
      });
    },

    formatData(v) {
      this.user.date_birth = !v ? '' : moment(v).format('DD/MM/YYYY');
    },

    getCategory() {
      this.category = localStorage.getItem('user-category');
    },

    getOut() {
      localStorage.clear();
      this.$router.replace('/psicologo/login');
    },

    onEdit(value) {
      this.isEdit = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  height: auto;
  color: #f7f1e4;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

* >>> .v-text-field__slot .v-label,
* >>> .v-select__slot .v-label {
  color: #02a554;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.button-anchor {
  border-radius: 8px;
  text-transform: uppercase;
  font-weight: 500;
  height: 36px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  text-decoration: none;
  margin: 0px 5px;
}

.avatar-psicologo {
  position: absolute;
  left: -50px;
  top: 0;
}

.box-psicologo {
  background: #e8e8e8;
  padding: 13px 0;
  border-radius: 12px;
  width: calc(100% - 46px);
  position: relative;
}

@media screen and (max-width: 1024px) {
  .avatar-psicologo {
    position: initial;
    left: unset;
    top: unset;
  }

  .box-psicologo {
    width: 100%;
  }
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}

.box-contact {
  background-color: #f7f7f7;
  padding: 16px;
  color: #6f6f6f;
  font-size: 18px;
  flex-wrap: wrap;

  > * {
    flex: 0 0 auto !important;
  }

  p {
    margin: 0;
  }

  .titulo-habilitacoes {
    font-size: 20px;
    margin-right: 20px;
    font-weight: bold;
  }
}

h2 {
  color: var(--v-primary-base);
}

.specialities {
  padding: 10px 15px;
  background: #02a554;
  color: white;
  border-radius: 25px;
}

.photoOPP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  border: solid 1px #707070;
  padding: 32px 16px;
  border-radius: 10px;
}

.biographty-text {
  white-space: pre-wrap;
  p {
    margin-bottom: 0;
  }
}
</style>
